'use client'

import { useMedia } from '@/hooks'
import { Typo3Video } from '@/types/typo3'
import { MEDIA } from '@spot'
import dynamic from 'next/dynamic'

// PlyrLazy bundles plyr's CSS into this lazy chunk, keeping it out of the
// render-blocking CSS for pages containing this component.
const Plyr = dynamic(
  async () => await import('@/ui/components/media/PlyrLazy'),
  {
    ssr: false
  }
)

interface Props {
  video: Typo3Video

  provider: Plyr.Provider
}
const Video = ({ video, provider }: Props) => {
  const isDesktop = useMedia(MEDIA.desktop, true)

  return (
    <Plyr
      source={{
        type: 'video',
        sources: [
          {
            src: video?.publicUrl,
            provider: provider
          }
        ]
      }}
      options={{
        controls: [
          'play',
          'progress',
          'current-time',
          'mute',
          'volume',
          isDesktop ? 'fullscreen' : ''
        ],
        fullscreen: {
          enabled: isDesktop ? true : false
        }
      }}
    />
  )
}

export default Video
